module.exports = __webpack_public_path__ + "media/images/common/nav_mycatalog-7432f020b1f66352e4f3ec9dff009136.gif";